import React, { lazy, Suspense } from 'react';
import cn from 'classnames';
import Modal from 'components/UI/Modal';
import CloseButton from 'components/UI/CloseButton';
import Loader from 'components/UI/Loader';
import Title from 'components/UI/Title';
import Contacts from 'components/UI/Contacts';
import ModalAside from 'components/ModalAside';
import { useOpenModalEventHandler } from 'components/Modals';
import { useTrans, useLang } from 'utils/localisation';

import * as styles from './RequestConsultation.module.scss';

const CorporateForm = lazy(() => import('components/Forms/CorporateForm/CorporateForm'));

export default function RequestConsultation({
  animation = 'show',
  isOpen,
  closeModalCallback,
  title,
  subtitle,
  id = 'request-consultation',
  formName = 'request-consultation',
  commentPlaceholder,
  commentPlaceholderMessage,
  withAgreement,
  withNda,
  withAttach,
  modalAsideData,
  additionalFormData,
  submitTitle,
}) {
  const lang = useLang();
  const t = useTrans(['common', 'requestConsultation']);
  const shouldShowAside = lang !== 'ae';

  useOpenModalEventHandler(isOpen, 'request_consultation');

  return (
    <Modal
      isOpen={isOpen}
      closeModalCallback={closeModalCallback}
      closeButton={false}
      containerMod={shouldShowAside ? 'withAside' : null}
      contentMod="noPadding"
      animation={animation}
    >
      {onClose => (
        <div className={styles.container}>
          <div className={cn(styles.formWrap, !shouldShowAside && styles.withoutAside)}>
            <Title tag="h3" className={styles.title}>
              {title ?? t('requestConsultation')}
            </Title>
            {subtitle && (
              <p className={cn(styles.subtitle, styles.mobileHidden)} color="black">
                {subtitle}
              </p>
            )}
            {!shouldShowAside && <Contacts className={styles.contacts} />}
            <CloseButton onClose={onClose} theme="dark" />
            <Suspense
              fallback={
                <div className={styles.loaderWrap}>
                  <Loader theme="fullHeight" />
                </div>
              }
            >
              <CorporateForm
                id={id}
                submitTitle={submitTitle ?? t('buttonName')}
                closeModal={onClose}
                commentPlaceholder={commentPlaceholder}
                commentPlaceholderMessage={commentPlaceholderMessage}
                captchaMinHidden={false}
                ndaPositionTop={true}
                inModal={true}
                withAgreement={withAgreement}
                withNda={withNda}
                withAttach={withAttach}
                theme="consultation"
                formName={formName}
                additionalFormData={additionalFormData}
              />
            </Suspense>
          </div>
          {shouldShowAside && (
            <ModalAside className={styles.mobileHidden} asideData={modalAsideData} />
          )}
        </div>
      )}
    </Modal>
  );
}
